import api from './api';

/**
 * Content media: the per-content-type upload spec plus the multi-asset (carousel) endpoints.
 * All routes live under /api/v1/** so responses are wrapped in ApiResponse — we unwrap
 * `response.data.data`.
 */
const mediaService = {
  /**
   * The media spec for a content type (file count, kinds, size/duration caps, derived
   * `accept`/`multiple`/`requiresMedia`). Drives the uploader UI.
   * @returns {Promise<object>}
   */
  getSpec: async (type) => {
    const res = await api.get('/api/v1/content/media-spec', { params: { type } });
    return res.data.data;
  },

  /** Presign a PUT for one slide (does not change the content item's status). */
  getSlideUploadUrl: async (contentId, contentType) => {
    const res = await api.post(`/api/v1/content/${contentId}/media/upload-url`, null, {
      params: { contentType },
    });
    return res.data.data;
  },

  /** Attach an already-uploaded asset to a content item's media set. */
  appendMedia: async (contentId, { s3Key, kind, sizeBytes, durationSec, thumbnailUrl }) => {
    const res = await api.post(`/api/v1/content/${contentId}/media`, {
      s3Key, kind, sizeBytes, durationSec, thumbnailUrl,
    });
    return res.data.data;
  },

  /** List a content item's media assets, in slot order. */
  listMedia: async (contentId) => {
    const res = await api.get(`/api/v1/content/${contentId}/media`);
    return res.data.data;
  },

  /** Remove one asset. Returns the updated, compacted list. */
  deleteMedia: async (contentId, mediaId) => {
    const res = await api.delete(`/api/v1/content/${contentId}/media/${mediaId}`);
    return res.data.data;
  },

  /** Reorder assets — `orderedIds` must be a permutation of the current media ids. */
  reorderMedia: async (contentId, orderedIds) => {
    const res = await api.put(`/api/v1/content/${contentId}/media/reorder`, { orderedIds });
    return res.data.data;
  },
};

export default mediaService;
